<script>
    import { navigate } from "svelte-navigator";
    import { uuidv7 } from "@kripod/uuidv7";
    import { translator, loading } from "../../store";
    import {
        Card,
        TextInput,
        Button,
        SelectNew,
        AutocompleteNew
    } from "../../components/index.svelte";
    import {
        createOffer,
        updateOffer,
        getOfferByID,
        getUSDExchangeRate,
        getCompanyAutocompleteList
    } from "../../helpers/apiHelpers/index.svelte";
    import { toast } from "../../helpers/utils.svelte";
    import { onMount } from "svelte";

    export let offerID = null;
    let formTitle = offerID ? "Teklif Düzenleme Formu" : "Teklif Oluşturma Formu";
    let formType = offerID ? "edit" : "create";
    let offerDetails = {
    };

    // Teklif kalemleri için boş dizi
    let offerItems = [];

    // Toplam tutarları tutacak değişkenler
    let totalSubtotal = 0;
    let totalVatAmount = 0;
    let grandTotal = 0;
    let exchangeRate = 1;
    let discountTL = 0;
    let discountUSD = 0;
    let companyAutocompleteList = [];

    onMount(async () => {
        companyAutocompleteList = await getCompanyAutocompleteList();
        console.log('companyAutocompleteList', companyAutocompleteList);
        if (offerID) {
            let remoteOfferDetails = await getOfferByID(offerID);
            if (remoteOfferDetails) {
                offerDetails.company_name = remoteOfferDetails.company.name;
                offerDetails.company_contact_person = remoteOfferDetails.company.contact_person;
                offerDetails.company_phone = remoteOfferDetails.company.phone;
                offerDetails.company_email = remoteOfferDetails.company.email;
                offerDetails.company_address = remoteOfferDetails.company.address;
                offerDetails.company_district = remoteOfferDetails.company.district;
                offerDetails.company_city = remoteOfferDetails.company.city;
                offerDetails.company_tax_office = remoteOfferDetails.company.tax_office;
                offerDetails.company_tax_number = remoteOfferDetails.company.tax_number;
                offerDetails.offer_description = remoteOfferDetails.description;
                offerDetails.offer_ref_no = remoteOfferDetails.ref_no;

                exchangeRate = remoteOfferDetails.exchange_rate;
                discountTL = remoteOfferDetails.discount_tl;
                discountUSD = (discountTL / exchangeRate).toFixed(2);
                offerItems = remoteOfferDetails.items.map(item => ({
                    id: item.id,
                    length: item.length,
                    description: item.description,
                    unit: item.unit,
                    quantity: item.quantity,
                    unitPriceTL: item.unit_price_tl,
                    unitPriceUSD: (item.unit_price_tl / exchangeRate).toFixed(2),
                    vatRate: item.vat_rate,
                    total: item.total
                }));
            }
            console.log('ININI', offerDetails, offerItems);
        } else {
            // Yeni teklif oluşturulurken güncel döviz kurunu al
            exchangeRate = await getUSDExchangeRate();
        }
    });

    // Yeni malzeme ekleme fonksiyonu
    function addNewItem() {
        console.log(uuidv7());
        offerItems = [...offerItems, {
            id: uuidv7(),
            length: 0,
            description: "",
            unit: "ADET",
            quantity: 1,
            unitPriceTL: 0,        // TL cinsinden birim fiyat
            unitPriceUSD: 0,       // USD cinsinden birim fiyat
            vatRate: "20",
            total: 0
        }];
    }

    // Malzeme silme fonksiyonu
    function removeItem(index) {
        // Seçilen indeksteki öğeyi kaldır
        offerItems = offerItems.filter((_, i) => i !== index);
    }

    function onUnitPriceChange(item, index, currency) {
        return (val) => {
            let updatedItems = [...offerItems];
            if (currency === "TL") {
                updatedItems[index] = {
                    ...item,
                    unitPriceTL: val,
                    unitPriceUSD: (val / exchangeRate).toFixed(2)
                };
            } else {
                updatedItems[index] = {
                    ...item,
                    unitPriceUSD: val,
                    unitPriceTL: (val * exchangeRate).toFixed(2)
                };
            }
            offerItems = updatedItems;
        }
    }

    // Her bir kalem için hesaplamaları güncelleyen fonksiyon
    function updateItemCalculations(item) {
        item.total = (item.quantity * item.unitPriceTL) * (1 + Number(item.vatRate) / 100);
        return item;
    }


    async function handleSubmit(e) {
        const offerFormData = new FormData(e.target);
        try {
            let saveResp = null;
            if (formType === "edit" && offerID) {
                saveResp = await updateOffer(offerID, offerFormData);
            } else {
                saveResp = await createOffer(offerFormData);
            }
            if (!saveResp.id) {
                throw new RequestError("Bilinmeyen Hata #o4Wi", {
                    message: "Bilinmeyen Hata #o4Wi",
                });
            }
            window.scrollTo({ top: 0 });
            navigate(-1);
            toast.success(
                translator("Başarılı"),
                formType === "edit"
                    ? translator("Değişiklikler Kaydedildi")
                    : translator("Teklif oluşturuldu")
            );
        } catch (err) {

            toast.error(translator("Hata"), translator(err.getResponseMessage()));
            console.log(err);
        }
    }

    function onDiscountChange(discountType) {
        return (value) => {
            if (!value) {
                value = 0;
            }
            if (discountType === "TL") {
                discountUSD = (value / exchangeRate).toFixed(2);
            } else {
                discountTL = (value * exchangeRate).toFixed(2);
            }
        }
    }

    function handleCompanyChange(value) {
        console.log('handleCompanyChange', value);
        let company = companyAutocompleteList[value];
        if (company) {
            offerDetails.company_name = company.name;
            offerDetails.company_contact_person = company.contact_person;
            offerDetails.company_phone = company.phone;
            offerDetails.company_email = company.email;
            offerDetails.company_address = company.address;
            offerDetails.company_district = company.district;
            offerDetails.company_city = company.city;
            offerDetails.company_tax_office = company.tax_office;
            offerDetails.company_tax_number = company.tax_number;
        }
    }

    // Döviz kuru değiştiğinde tüm hesaplamaları güncelle
    $: {
        offerItems = offerItems.map(item => updateItemCalculations(item));
        totalSubtotal = offerItems.reduce((sum, item) => sum + (item.quantity * item.unitPriceTL), 0);
        totalVatAmount = offerItems.reduce((sum, item) => sum + ((item.quantity * item.unitPriceTL * item.vatRate) / 100), 0);

        // Genel toplamdan iskontoyu düş
        grandTotal = totalSubtotal + totalVatAmount - discountTL;
    }

</script>
<Card headerText={formTitle}>
    <form
    class="basic-form"
    id="user-form"
    on:submit|preventDefault={handleSubmit}
    >
    <div class="row">
        <div class="col-md-12">
            <div class="col-md-12 p-2">
                <AutocompleteNew
                    fieldName="company_name"
                    label="Alıcı Şirket"
                    required
                    value={offerDetails?.company_name}
                    options={companyAutocompleteList ? Object.keys(companyAutocompleteList) : null}
                    onChange={handleCompanyChange}
                />
            </div>
            <div class="col-md-12 p-2">
                <TextInput
                fieldName="company_contact_person"
                label="Alıcı Şirket Yetkilisi"
                required
                value={offerDetails?.company_contact_person}
                />
            </div>
            <div class="col-md-12 p-2">
                <div class="row">
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_phone"
                        label="Alıcı Telefon Numarası"
                        required
                        value={offerDetails?.company_phone}
                        />
                    </div>
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_email"
                        label="Alıcı E-Posta"
                        required
                        value={offerDetails?.company_email}
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-12 p-2">
                <TextInput
                fieldName="company_address"
                label="Alıcı Adresi"
                required
                value={offerDetails?.company_address}
                />
            </div>
            <div class="col-md-12 p-2">
                <div class="row">
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_district"
                        label="Alıcı İlçe"
                        required
                        value={offerDetails?.company_district}
                        />
                    </div>
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_city"
                        label="Alıcı İl"
                        required
                        value={offerDetails?.company_city}
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-12 p-2">
                <div class="row">
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_tax_office"
                        label="Alıcı Vergi Dairesi"
                        required
                        value={offerDetails?.company_tax_office}
                        />
                    </div>
                    <div class="col-md-6">
                        <TextInput
                        fieldName="company_tax_number"
                        label="Alıcı VKN"
                        required
                        value={offerDetails?.company_tax_number}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 p-2">
            <div class="row mb-3">
                <div class="col-md-9 p-2">
                    <TextInput
                    type="textarea"
                    fieldName="offer_description"
                    label="Teklif Açıklaması"
                    rows="3"
                    placeholder=""
                    />
                </div>
                <div class="col-md-3 p-2">
                    <TextInput
                    type="number"
                    fieldName="exchange_rate"
                    label="Dolar Kuru (USD/TL)"
                    min="0"
                    step="0.0001"
                    defaultValue="0"
                    bind:value={exchangeRate}
                    />
                </div>
                <div class="col-md-12 p-2">
                    <TextInput
                    fieldName="offer_ref_no"
                    label="Teklif Referans Numarası"
                    value={offerDetails?.offer_ref_no}
                    />
                </div>
            </div>
            <div class="table-responsive overflow-y-scroll hide-scrollbar" >
                <table class="table table-bordered table-striped sticky-header" style="min-width: 900px">
                    <thead class="table-sticky-top bg-white table-small-text">
                        <tr>
                            <th class="narrow-column text-wrap text-center align-middle">Sıra No</th>
                            <th class="narrow-column text-wrap text-center align-middle">Boy (MT)</th>
                            <th class="text-wrap text-center align-middle">Ürün Tanımı</th>
                            <th class="narrow-column text-wrap text-center align-middle">Birim</th>
                            <th class="narrow-column text-wrap text-center align-middle">Miktar</th>
                            <th class="narrow-column text-wrap text-center align-middle">Birim Fiyat (₺)</th>
                            <th class="narrow-column text-wrap text-center align-middle">Birim Fiyat ($)</th>
                            <th class="narrow-column text-wrap text-center align-middle">KDV %</th>
                            <th class="narrow-column text-wrap text-center align-middle">Toplam (₺)</th>
                            <th class="narrow-column text-wrap text-center align-middle">Toplam ($)</th>
                            <th class="narrow-column text-wrap text-center align-middle">İşlemler</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each offerItems as item, index}
                            <tr>
                                <td class="text-center narrow-column">
                                    {index + 1}
                                    <input type="hidden" name={`items[${index}][item_id]`} value={item.id} />
                                </td>
                                <td class="narrow-column">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName={`items[${index}][length]`}
                                    min="0"
                                    step="0.01"
                                    hideLabel
                                    bind:value={item.length}
                                    />
                                </td>
                                <td>
                                    <AutocompleteNew
                                        compact={true}
                                        type="text"
                                        fieldName={`items[${index}][description]`}
                                        hideLabel
                                        options={["Ürün 1", "Ürün 2", "Ürün 3"]}
                                        bind:value={item.description}
                                    />
                                    <!-- <TextInput
                                    compact={true}
                                    type="text"
                                    fieldName={`items[${index}][description]`}
                                    hideLabel
                                    bind:value={item.description}
                                    /> -->
                                </td>
                                <td class="narrow-column">
                                    <SelectNew
                                    fieldName={`items[${index}][unit]`}
                                    compact={true}
                                    selectOptions={[
                                        { value: "ADET", label: "Adet" },
                                        { value: "METRE", label: "Metre" }
                                    ]}
                                    valueField="value"
                                    labelField="label"
                                    hideLabel
                                    bind:value={item.unit}
                                    />
                                </td>
                                <td class="narrow-column">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName={`items[${index}][quantity]`}
                                    min="1"
                                    hideLabel
                                    bind:value={item.quantity}
                                    />
                                </td>
                                <td class="narrow-column">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName={`items[${index}][unitPriceTL]`}
                                    min="0"
                                    step="0.01"
                                    hideLabel
                                    onChange={onUnitPriceChange(item, index, "TL")}
                                    bind:value={item.unitPriceTL}
                                    />
                                </td>
                                <td class="narrow-column">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName={`items[${index}][unitPriceUSD]`}
                                    min="0"
                                    step="0.01"
                                    hideLabel
                                    onChange={onUnitPriceChange(item, index, "USD")}
                                    bind:value={item.unitPriceUSD}
                                    />
                                </td>
                                <td class="narrow-column">
                                    <SelectNew
                                        compact={true}
                                        fieldName={`items[${index}][vatRate]`}
                                        selectOptions={[
                                            { value: "0", label: "0%" },
                                            { value: "10", label: "10%" },
                                            { value: "20", label: "20%" }
                                        ]}
                                        valueField="value"
                                        labelField="label"
                                        hideLabel
                                        bind:value={item.vatRate}
                                    />
                                </td>
                                <td class="text-end narrow-column">
                                    {item.total.toFixed(2)}
                                </td>
                                <td class="text-end narrow-column">
                                    {exchangeRate > 0 ? (item.total / exchangeRate).toFixed(2) : ''}
                                </td>
                                <td class="narrow-column">
                                    <button type="button"
                                    class="btn btn-danger btn-sm"
                                    on:click={() => removeItem(index)}>
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                            </tr>
                        {/each}
                </tbody>
            </table>
        </div>
        <div class="row mt-3 mb-3">
            <div class="col-md-6">
                <div class="table-responsive" style="max-height: none;">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-end">TL</th>
                                <th class="text-end">USD</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="fw-bold">Ara Toplam:</td>
                                <td class="text-end">{totalSubtotal.toFixed(2)}</td>
                                <td class="text-end">
                                    {#if exchangeRate > 0}
                                    {(totalSubtotal / exchangeRate).toFixed(2)}
                                    {/if}
                                </td>
                            </tr>
                            <tr>
                                <td class="fw-bold">Toplam KDV:</td>
                                <td class="text-end">{totalVatAmount.toFixed(2)}</td>
                                <td class="text-end">
                                    {#if exchangeRate > 0}
                                    {(totalVatAmount / exchangeRate).toFixed(2)}
                                    {/if}
                                </td>
                            </tr>
                            <tr>
                                <td class="fw-bold">İskonto:</td>
                                <td class="text-end">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName="discount_tl"
                                    min="0"
                                    step="0.01"
                                    hideLabel
                                    style="text-align: right;"
                                    onChange={onDiscountChange("TL")}
                                    bind:value={discountTL}
                                    />
                                </td>
                                <td class="text-end">
                                    <TextInput
                                    type="number"
                                    compact={true}
                                    fieldName="discount_usd"
                                    min="0"
                                    step="0.01"
                                    hideLabel
                                    style="text-align: right;"
                                    onChange={onDiscountChange("USD")}
                                    bind:value={discountUSD}
                                    />
                                </td>
                            </tr>
                            <tr class="table-primary">
                                <td class="fw-bold">Genel Toplam:</td>
                                <td class="text-end fw-bold">{grandTotal.toFixed(2)}</td>
                                <td class="text-end fw-bold">
                                    {#if exchangeRate > 0}
                                    {(grandTotal / exchangeRate).toFixed(2)}
                                    {/if}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-end mt-2">
                    <button type="button"
                    class="btn btn-sm btn-primary"
                    on:click={addNewItem}>
                    <i class="fas fa-plus me-1"></i>
                    Yeni Malzeme Ekle
                </button>
            </div>
        </div>
    </div>
</div>
</div>
<hr />
<div class="gap-2 d-flex justify-content-end align-items-center">
    <Button formName="user-form" colorCls="btn-success">
        {translator("Kaydet")}
    </Button>
    <Button onClick={() => navigate(-1)} colorCls="btn-dark">
        {translator("Vazgeç")}
    </Button>
</div>
</form>
</Card>

<style>
    .table-responsive {
        max-height: 400px;  /* Tablonun maksimum yüksekliği */
        overflow-y: auto;
    }

    .sticky-header thead th {
        position: sticky;
        top: 0;
        background-color: #fff;  /* Başlık arka plan rengi */
        z-index: 1;
        /* Başlık altına gölge ekleyelim */
        box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    }

    .hide-scrollbar::-webkit-scrollbar {
        display: none;
    }

    .table-small-text th{
        font-size: 0.9rem !important;
    }

    .table th, .table td {
        padding: 4px;
    }

    /* Dar sütunlar için özel genişlik */
    .table th.narrow-column,
    .table td.narrow-column {
        width: 70px;
        max-width: 70px;
    }
</style>